import { AUTH_PAYLOAD_KEY } from "../../domain/auth/Repositories/LocalStorageAuthRepository"
import { isReviewerToken } from "./reviewerSession.ts"

export * from "./reviewerSession.ts"
export * from "./readOnlyProfile.ts"

/** Reads the current access token from localStorage (auth_payload) and checks the `reviewer` claim. */
export function isReviewerSession(): boolean {
  try {
    const item = localStorage.getItem(AUTH_PAYLOAD_KEY)
    if (!item) return false
    return isReviewerToken(JSON.parse(item)?.token)
  } catch {
    return false
  }
}
